import HttpRequest from "./HttpRequest";

export default class CommissioningService {

  httpRequest = new HttpRequest();

  commissioner(checkpointId, productTypeId, quantity = 1, tagId) {
    const url = `ton/v1/product-types/${productTypeId}/checkpoints/${checkpointId}/commissioner`;
    return this.httpRequest.post(url,
        {quantity, checkpointId, productTypeId, tagId});
  }

}



// WEBPACK FOOTER //
// ./src/services/CommissioningService.js